
export const SITE_URLS = {
  MAIN: '/',
  ORG_HOME: '/org',
  ERROR: '/error/',
  ROLES_SETTINGS: '/roles-settings',
  LANDING: '/landing',
  LOGIN: '/login',
  FORGET_PASSWORD: '/forgetpassword',
  SUBSCRIPTION_PLANS: '/subscription-plans',
  ORG_USERS_MANAGEMENT: '/users-management',
  INTERNAL_USERS: '/internal/users',
  PUBLIC_USERS: '/public/users',
  CAMPAIGNS: '/campaigns',
  CAMPAIGN_SIGNEES: '/campaign-signees',
  ACCOUNT_INFO: '/account/info',
  CHANGE_PASSWORD: '/account/changepassword',
  ACCOUNT_SUB: '/account/subscription',
  ORG: '/organisations',
  DETAIL: '/detail',
  CREATE: 'create',
  SUBSCRIPTIONS: '/subscriptions',
  TAAS: '/taas',
  AIDE: '/aide',
  AIDE_SCOUT_MANAGER: '/aide/scout-manager',
  AIDE_CREATE_SCOUT: '/aide/scout-manager/create',
  AIDE_NERD_TRAINING: '/aide/nerd-training',
  ALL_SCOUTS: '/scouts',
  SEER_DEMO: '/seerdemo',
  SEARCH_COMPANY: '/search/companies',
  COMPANY_DETAIL: '/companies',
  KEY_DEV_MANAGER: '/aide/key-dev-manager',
  KEY_DEV_REQUEST_LOG: '/aide/key-dev-request-log',
  KEY_DEV_QUALITY_MONITORING: '/aide/key-dev-request-log',
  KEY_DEV_DETAIL_UPDATE_HISTORY: '/aide/key-dev-manager/update-history',
  KEY_DEV_CLUSTER_MANAGEMENT: '/aide/key-dev-cluster-manager',
};

export const DEFAULT_ROUTE = {
  'Campaign Management': SITE_URLS.CAMPAIGN_SIGNEES,
  Subscriptions: SITE_URLS.SUBSCRIPTION_PLANS,
  'User Management': SITE_URLS.PUBLIC_USERS,
  'Organisation Management': SITE_URLS.ORG,
};

export const COMMON_ROUTE_PATHS = {
  LANDING: '/landing',
  ERROR: '/error',
  MAIN: '/',
  LOGIN: '/login',
  FORGET_PASSWORD: '/forgetpassword',
  RESET_PASSWORD: '/resetpassword/:resetType/:resetKey',
  ACCOUNT_INFO: '/account/:option',
  CALLBACK: '/callback',
  SILENT: '/silent',
};

export const PUBLIC_ROUTE_PATHS = {
  HOME: '/org/:organisationGuid',
  ROLES_MANAGEMENT: '/org/:organisationGuid/roles-management/:roleGuid?',
  ORG_USERS_MANAGEMENT: '/org/:organisationGuid/users-management/:userGuid?',
  ORG_SUB_MANAGEMENT: '/org/:organisationGuid/subscriptions/:subGuid?',
};

export const INTERNAL_ROUTE_PATHS = {
  ROLES_SETTINGS: '/roles-settings',
  ROLES_SETTINGS_CREATE: '/roles-settings/create',
  ROLES_SETTINGS_INFO: '/roles-settings/:roleGuid?',
  LOGIN: SITE_URLS.LOGIN,
  TAAS: `${SITE_URLS.TAAS}/:articleId?`,
  AIDE: '/aide',
  AIDE_SCOUT_MANAGER: '/aide/scout-manager',
  AIDE_SCOUT_MANAGER_CREATE: '/aide/scout-manager/create/:scoutType?',
  AIDE_SCOUT_MANAGER_INFO: '/aide/scout-manager/:scoutGuid?',
  AIDE_NERD_TRAINING_ENTRANCE: SITE_URLS.AIDE_NERD_TRAINING,
  AIDE_NERD_TRAINING: `${SITE_URLS.AIDE_NERD_TRAINING}/:articleId`,
  ALL_SCOUTS: SITE_URLS.ALL_SCOUTS,
  SUBSCRIPTION_PLANS: '/subscription-plans',
  SUBSCRIPTION_PLANS_CREATE: '/subscription-plans/create',
  SUBSCRIPTION_PLANS_INFO: '/subscription-plans/:subPlanGuid?',
  INTERNAL_USERS: '/internal/users',
  INTERNAL_USERS_CREATE: '/internal/users/create',
  INTERNAL_USERS_INFO: '/internal/users/:userGuid?',
  PUBLIC_USERS: '/public/users',
  PUBLIC_USERS_CREATE: '/public/users/create',
  PUBLIC_USERS_INFO: '/public/users/:userGuid?',
  CAMPAIGNS: '/campaigns',
  CAMPAIGNS_CREATE: '/campaigns/create',
  CAMPAIGNS_INFO: '/campaigns/:campaignGuid?',
  CAMPAIGN_SIGNEES: '/campaign-signees',
  CAMPAIGN_SIGNEES_CREATE: '/campaign-signees/create',
  CAMPAIGN_SIGNEES_INFO: '/campaign-signees/:cUserGuid?',
  ORG: '/organisations',
  ORG_CREATE: '/organisations/create',
  ORG_INFO: '/organisations/:orgMgmtGuid',
  // ORG_MANAGEMENT_ROLES: '/organisation-management/:orgMgmtGuid/roles-management/:roleGuid?',
  // ORG_MANAGEMENT_USERS: '/organisation-management/:orgMgmtGuid/users-management/:userGuid?',
  // ORG_MANAGEMENT_SUB: '/organisation-management/:orgMgmtGuid/subscriptions/:subGuid?'
  SEER_DEMO: SITE_URLS.SEER_DEMO,
  KEY_DEV_MANAGER: '/aide/key-dev-manager',
  KEY_DEV_REQUEST_LOG: '/aide/key-dev-request-log',
  KEY_DEV_QUALITY_MONITORING: '/aide/key-dev-quality-monitoring',
  KEY_DEV_MANAGER_DETAIL: '/aide/key-dev-manager/:keydevId?',
  KEY_DEV_MANAGER_DETAIL_UPDATE_HISTORY: '/aide/key-dev-manager/update-history/:keydevId?',
  KEY_DEV_CLUSTER_MANAGEMENT: '/aide/key-dev-cluster-manager',
};

export const EXTERNAL_ROUTE_PATHS = {
  COMPANY_DETAIL: '/companies/:companyGuiId?',
};
